import { jsx as C } from "react/jsx-runtime";
import "react";
var L = (r) => /* @__PURE__ */ C("svg", {
  width: "100%",
  height: "100%",
  viewBox: "0 0 32 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...r,
  children: /* @__PURE__ */ C("path", {
    d: "M0 15C0 6.71573 6.60225 0 14.7465 0C22.3189 0 28.5533 5.80619 29.3923 13.2803L29.483 13.1895C30.0588 12.6039 30.9924 12.6039 31.5683 13.1895C32.1439 13.7752 32.1439 14.7248 31.5683 15.3105L28.6204 18.3105C28.3441 18.5917 27.9686 18.7498 27.5778 18.75C27.1867 18.7501 26.8103 18.5918 26.5337 18.3105L23.5844 15.3105L23.4821 15.1963C23.0103 14.6072 23.0448 13.7385 23.5844 13.1895C24.1243 12.6404 24.9782 12.6062 25.5573 13.0869L25.6696 13.1895L26.502 14.0361C26.0192 7.85957 20.9429 3 14.7465 3C8.23111 3 2.94931 8.37258 2.94931 15C2.94931 21.6274 8.23111 27 14.7465 27C18.4519 27 21.7577 25.2642 23.9228 22.5425C24.4351 21.8986 25.3634 21.7989 25.9965 22.3198C26.6296 22.8409 26.7276 23.7852 26.2154 24.4292C23.5144 27.8245 19.3797 30 14.7465 30C6.60225 30 0 23.2843 0 15ZM13.2719 7.5C13.2719 6.67157 13.9321 6 14.7465 6C15.561 6 16.2212 6.67157 16.2212 7.5V14.1973L19.9885 16.752L20.1094 16.8428C20.6867 17.3262 20.8211 18.1856 20.3975 18.832C19.974 19.4782 19.1427 19.6827 18.4821 19.3271L18.3525 19.248L13.9286 16.248C13.5183 15.9698 13.2719 15.5015 13.2719 15V7.5Z",
    fill: "currentColor"
  })
});
export {
  L as default
};
